import { addOutcome, outcomesAvailable, selectedOutcomeIds } from 'model/EvidenceSearch'
import { AttributesGrid } from './AttributesGrid'
import { reactive, VString } from 'alkali'
import { OutcomeDropdown } from './OutcomeDropdown'

export class OutcomesGrid extends AttributesGrid.with({
	selected: selectedOutcomeIds,
	Dropdown: OutcomeDropdown,
	id: 'outcome-filter-grid',
}) {
	created(properties) {
		properties.collection = outcomesAvailable
		properties.placeholder = 'For the measure of ...'
		properties.label = 'Outcome'
		properties.attributeType = 'outcome'
		properties.addTerm = addOutcome
	}
}